module.exports = __webpack_public_path__ + "870299922ee3cc1ac6d42b386133f716.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room8/audio5/08_5MCA-The-Apartment.ogg
// module id = 797
// module chunks = 0